export default "__VITE_ASSET__D5xB7rlR__"